import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/jobsiq/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import JobsList from "./pages/JobsList";
import JobDetail from "./pages/JobDetail";
import PostJob from "./pages/PostJob";
import Applicants from "./pages/Applicants";
import Chatbot from "./pages/Chatbot";
import VideoInterview from "./pages/VideoInterview";
import Profile from "./pages/Profile";
import PublicProfile from "./pages/PublicProfile";
import PublicReport from "./pages/PublicReport";
import SavedJobs from "./pages/SavedJobs";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";

function AppRouter() {
    const location = useLocation();
    // Intercept OAuth callback (session_id in URL fragment) synchronously.
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/jobs" element={<JobsList />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/p/:userId" element={<PublicProfile />} />
            <Route path="/r/:token" element={<PublicReport />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/post-job"
                element={
                    <ProtectedRoute role="company">
                        <PostJob />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/applicants/:jobId"
                element={
                    <ProtectedRoute role="company">
                        <Applicants />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/chatbot"
                element={
                    <ProtectedRoute>
                        <Chatbot />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/video-interview"
                element={
                    <ProtectedRoute>
                        <VideoInterview />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/video-interview/:applicationId"
                element={
                    <ProtectedRoute>
                        <VideoInterview />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/profile"
                element={
                    <ProtectedRoute>
                        <Profile />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/saved"
                element={
                    <ProtectedRoute role="seeker">
                        <SavedJobs />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
